<!--
 * @Description:
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form label-width="120px" :model="formParams" ref="form">
      <el-form-item
        :label="item.label"
        v-for="item in form"
        :key="item.key"
        :prop="item.key"
        :rules="item.rules || []"
        :style="{ width: item.width }"
      >
        <template v-if="item.slot === 'dicSelect'">
          <dic-select
            style="width:100%;"
            v-on="item.listener"
            @dic-select-obj="
              val => {
                item.callback && item.callback(val);
                formParams[item.key] = val[item.attrs.useValueKey];
                item.key1 &&
                  item.attrs.useValueKey1 &&
                  (formParams[item.key1] = val[item.attrs.useValueKey1]);
              }
            "
            :fuzzyDef="item.selectAjax"
            v-bind="item.attrs"
            :placeholder="item.placeholder"
            class="data-item"
          ></dic-select>
        </template>
        <template v-if="item.slot === 'input'">
          <el-input
            v-bind="item.attrs"
            :placeholder="item.placeholder"
            v-model="formParams[item.key]"
            class="data-item"
          />
        </template>
        <template v-if="item.slot === 'date'">
          <el-date-picker
            style="width:100%;"
            :placeholder="item.placeholder"
            :value-format="item.valueFormat"
            v-model="formParams[item.key]"
            class="data-item"
            :type="item.type || 'month'"
            v-bind="item.attrs"
            v-on="item.listener"
          ></el-date-picker>
        </template>
        <template v-if="item.slot === 'custom'">
          <component
            :is="item.component"
            :value="formParams[item.key]"
            v-bind="item.attrs"
            v-on="item.listener"
          ></component>
        </template>
      </el-form-item>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <el-button
        type="primary"
        @click="save"
        v-if="isAdd || isEdit"
        :disabled="isSaving"
      >
        保存
      </el-button>
      <el-button @click="$xrkDialog.remove()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import { taxPayment } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import OpenNewWin from '@/tools/openNewWin';
import uploadFile from './components/uploadFile';
import dateFormat from '@/tools/dateFormat';
const nowDate = new Date();
export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: {
    id: [Number, String],
    type: [Number, String],
    useSupplierEnterpriseName: [Number, String, Boolean]
  },
  data() {
    return {
      isSaving: false,
      formParams: {
        industryName: '',
        inEnterpriseName: '',
        industryId: '',
        enterpriseIdentifierNo: '',
        taxPaymentAnnexList: []
      }
    };
  },
  computed: {
    isAdd() {
      return !this.id;
    },
    isEdit() {
      return this.type == 2;
    },
    form() {
      if (this.isAdd || this.isEdit) {
        const { formParams, $refs } = this;
        const checkNumber = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('不能为空'));
          } else if (!/^[+]{0,1}(\d+)$/g.test(`${value}`)) {
            callback(new Error('请填写整数'));
          } else {
            callback();
          }
        };
        const inputRequired = [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ];
        const selectRequired = [
          { required: true, message: '请选择内容', trigger: 'change' }
        ];
        return [
          {
            label: '客户企业',
            slot: 'dicSelect',
            key: 'industryName',
            key1: 'industryId',
            selectAjax: taxPayment.settleCompany,
            callback: info => {
              formParams.industryId = info.id;
              formParams.enterpriseIdentifierNo = info.invoiceIdentifierNo;
              formParams.inEnterpriseName = info.inEnterpriseName;
              formParams.industryName = info.inEnterpriseName;
              $refs['form'].validateField([
                'industryName',
                'enterpriseIdentifierNo'
              ]);
            },
            attrs: {
              useValueKey: 'showEnterpriseName',
              useValueKey1: 'id',
              allowCreate: true,
              prop: {
                label: 'showEnterpriseName',
                code: 'id'
              },
              ajaxQuery: 'keyWord',
              ajaxQueryObj: {},
              defaultActive: {
                enterpriseName: formParams.inEnterpriseName,
                showEnterpriseName: formParams.inEnterpriseName,
                id: formParams.industryId
              }
            },
            placeholder: '请选择客户企业',
            rules: selectRequired
          },
          {
            label: '纳税人识别号',
            placeholder: '请输入纳税人识别号',
            slot: 'input',
            key: 'enterpriseIdentifierNo',
            rules: inputRequired
          },
          {
            label: '所得月份',
            placeholder: '请选择所得月份',
            slot: 'date',
            key: 'proofMonth',
            valueFormat: 'yyyy-MM',
            rules: selectRequired,
            attrs: {
              'picker-options': {
                disabledDate(time) {
                  return time > nowDate;
                }
              }
            },
            listener: {
              change: e => {
                if (e) {
                  const date = new Date(e);
                  const totalDay = new Date(
                    date.getFullYear(),
                    +date.getMonth() + 1,
                    0
                  ).getDate();
                  this.$set(this.formParams, 'startDt', `${e}-01`);
                  this.$set(this.formParams, 'endDt', `${e}-${totalDay}`);
                } else {
                  delete this.formParams['startDt'];
                  delete this.formParams['endDt'];
                }
              }
            }
          },
          {
            label: '完税人数',
            placeholder: '请输入完税人数',
            slot: 'input',
            key: 'peopleCount',
            rules: [
              {
                validator: checkNumber,
                trigger: 'blur'
              },
              ...inputRequired
            ]
          },
          {
            label: '税款所属期起',
            placeholder: '请选择税款所属期起',
            slot: 'date',
            type: 'date',
            key: 'startDt',
            valueFormat: 'yyyy-MM-dd',
            rules: selectRequired,
            attrs: {
              'picker-options': {
                disabledDate(time) {
                  return time > nowDate;
                }
              }
            }
          },
          {
            label: '税款所属期止',
            placeholder: '请选择税款所属期止',
            slot: 'date',
            type: 'date',
            key: 'endDt',
            valueFormat: 'yyyy-MM-dd',
            attrs: {
              'picker-options': {
                disabledDate(time) {
                  if (!formParams.startDt) {
                    return false;
                  }
                  return (
                    time > nowDate ||
                    dateFormat(time.getTime(), 'YYYY-MM-DD') <
                      formParams.startDt
                  );
                }
              }
            },
            rules: selectRequired
          },
          {
            width: '100%',
            label: '完税证明附件',
            slot: 'custom',
            key: 'taxPaymentAnnexList',
            component: {
              render: () => {
                return (
                  <div style="display: flex;flex-wrap: wrap;">
                    <uploadFile
                      fileList={formParams.taxPaymentAnnexList.map(i => ({
                        name: i.attachementName || i.name,
                        url: i.attachmentUrl || i.url
                      }))}
                      onSuccess={fileList => {
                        formParams.taxPaymentAnnexList = fileList;
                        try {
                          this.$refs['form'].validateField(
                            'taxPaymentAnnexList'
                          );
                        } catch (error) {}
                      }}
                    ></uploadFile>
                  </div>
                );
              }
            },
            rules: selectRequired
          }
        ];
      }
      return [
        {
          label: '客户企业',
          slot: 'input',
          key: this.useSupplierEnterpriseName
            ? 'csoEnterpriseName'
            : 'inEnterpriseName',
          attrs: {
            disabled: true
          }
        },
        {
          label: '纳税人识别号',
          slot: 'input',
          key: 'enterpriseIdentifierNo',
          attrs: {
            disabled: true
          }
        },
        {
          label: '所得月份',
          slot: 'input',
          key: 'proofMonth',
          attrs: {
            disabled: true
          }
        },
        {
          label: '完税人数',
          slot: 'input',
          key: 'peopleCount',
          attrs: {
            disabled: true
          }
        },
        {
          label: '税款所属期起',
          slot: 'input',
          key: 'startDt',
          attrs: {
            disabled: true
          }
        },
        {
          label: '税款所属期止',
          slot: 'input',
          key: 'endDt',
          attrs: {
            disabled: true
          }
        },
        {
          label: '完税证明附件',
          slot: 'custom',
          key: 'taxPaymentAnnexList',
          component: {
            props: { value: Array },
            render() {
              const { value = [] } = this;
              return (
                <div>
                  {value.map(item => {
                    return (
                      <el-button
                        type="text"
                        onClick={() => {
                          const newWin = new OpenNewWin();
                          newWin.createWin();
                          newWin.setUrl(item.attachmentUrl);
                        }}
                      >
                        {item.attachementName}
                      </el-button>
                    );
                  })}
                </div>
              );
            }
          }
        }
      ];
    }
  },
  methods: {
    save() {
      if (this.isSaving) {
        return;
      }
      this.$refs['form'].validate(v => {
        if (v) {
          this.isSaving = true;
          taxPayment
            .add({
              id: this.id,
              ...this.formParams,
              taxPaymentAnnexList: this.formParams.taxPaymentAnnexList.map(
                i => ({
                  attachementName: i.attachementName || i.name,
                  attachmentUrl: i.attachmentUrl || i.url,
                  dutyPaidProofId: this.id
                })
              )
            })
            .then(() => {
              this.$emit('confirm');
              this.$message.success('保存成功');
              this.$xrkDialog.remove();
            })
            .catch(() => {
              this.isSaving = false;
            });
        }
      });
    }
  },
  async created() {
    if (this.id) {
      const {
        data: { data }
      } = await taxPayment.detail({ id: this.id, type: this.type });
      this.formParams = {
        ...data,
        industryName: data.inEnterpriseName
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    &-item {
      width: 50%;
      margin-bottom: 45px;
    }
  }
  .data-item {
    width: 340px;
  }
}
</style>
